/**
 * 🔇 [AudioService v4.0] SES SİSTEMİ İPTAL EDİLDİ
 * Kullanıcı isteği üzerine tüm sesli özellikler kaldırılmıştır.
 */
class AudioService {
    constructor() {
        // console.warn("🔇 [AudioService] Ses sistemi devre dışı bırakıldı.");
    }
    unlock() { }
    startAmbience() { }
    stopAmbience() { }
    async speakTTS() { return Promise.resolve(); }
    stopAll() { }
}

export const audioManager = new AudioService();